export const PLACEHOLDERS_COPY = {
	ADD_ADDITIONAL_NOTES: '+ Add additional notes',
	ADD_A_BUSINESS_DEFINITION: '+ Add a business definition',
	ADD_A_COMMENT: 'Add a comment...',
	ADD_A_DESCRIPTION: '+ Add a description',
	ADD_A_TASK: 'Add a task',
	ADD_DESCRIPTION: 'Add a description...',
	ADD_HELPTEXT: '+ Add help text',
	ADD_OWNER: 'Add Owner',
	AI_BUSINESS_CONTEXT_LINE_1: 'Help Ari understand your business.',
	// eslint-disable-next-line max-len
	AI_BUSINESS_CONTEXT_LINE_2: 'Ari can read your metadata, but not the context that lives in spreadsheets, Slack threads, or in a teammate\'s head. If you have industry specific acronyms, your processes have drifted from the picklist values, or if a field means something different than what its label suggests, that\'s what goes here.',
	// eslint-disable-next-line max-len
	AI_BUSINESS_CONTEXT_LINE_3: 'Example: "We have 7 opportunity stages but reps only use 4. \'Qualification\' and \'Proposal\' are legacy. \'Partner\' means channel reseller, not integration vendor. Health Score is our custom 0-100 metric from usage + support data."',
	APP_DESCRIPTION: 'Describe this application, what it does, and how it fits into your tech stack.',
	APP_LABEL: 'Sandbox',
	APP_NAME: 'App Name',
	APP_USER: 'app@company.com',
	COMPANY_NAME: 'Company Name',
	CONFIRM_PASSWORD: 'Confirm Password',
	CURRENT_PASSWORD: 'Current Password',
	EMAIL: 'email@company.com',
	EMAIL_USER_SAMPLE: 'email@company.com',
	ENTER_YOUR_API_KEY: 'Enter your Api Key',
	ENTER_YOUR_USERNAME: 'Enter your username',
	FILE_NAME: 'File Name',
	FILTER_BY: (label: string | null | undefined) => `Filter by ${label ?? ''}`,
	FILTER_BY_TAG: 'Filter by Tag',
	FIRST_NAME: 'First Name',
	FROM_ORGANIZATION: 'From Organization',
	// eslint-disable-next-line max-len
	INITIATIVE_PROMPT: 'What are you trying to accomplish? Be specific about your goals, timeline. We\'ll take care of including all the Salesforce context.',
	LAST_NAME: 'Last Name',
	LINK_TITLE: 'Link Title (Optional)',
	LINK_URL: 'Link Url',
	NAME_YOUR_INITIATIVE: 'Name your initiative',
	NAME_YOUR_MONITOR: 'Name Your Monitor',
	NAME_YOUR_TASK: 'Name your task',
	NAME_YOUR_VIEW: 'Name Your View',
	NEW_PASSWORD: 'New Password',
	OTHER_PLEASE_SPECIFY: 'Other (please specify)',
	PASSWORD: 'Password',
	PASTE_FIELD_NAMES: 'Paste (CTRL+V) up to 100 field API names (case sensitive), comma or newline delimited',
	PASTE_YOUR_URL: 'Paste your url here...',
	SEARCH_BY_TITLE: 'Search By Title',
	SEARCH_DATA_DICTIONARY: 'Search for specific entities, or all of one type',
	SEARCH_DISPLAY_NAMES: 'Search Display Names',
	SEARCH_INITIATIVES: 'Search Initiatives',
	SEARCH_JIRA_ISSUES: 'Search for your Jira Issue title or number',
	SEARCH_MONITORS: 'Search Monitors',
	SEARCH_TAGS: 'Search Tags',
	SEARCH_TASKS: 'Search Tasks',
	SEARCH_TO_ADD: 'Search to add',
	SELECT_AN_APPLICATION: 'Select an application',
	SELECT_APP_GROUP: 'Select App Group',
	SELECT_INTEGRATIONS: 'Select Integrations',
	SELECT_PROJECT: 'Select Project',
	STAKEHOLDER_EMAIL: 'finance@company.com',
	STAKEHOLDER_NAME: 'Finance',
	TAG_DESCRIPTION: 'Tag Description',
	TAG_NAME: 'Tag Name',
	TAG_OWNERS: 'Select Tag Owners',
	TO_ORGANIZATION: 'To Organization'
};
